import { messages } from './messages';

/**
 * @param {string[]} acceptedFileTypes
 * @param {File} file
 * @returns {boolean}
 */
const validateFileType = (acceptedFileTypes, file) =>
  acceptedFileTypes.some((acceptedType) => {
    const normalizedType = acceptedType.toLowerCase();

    // Check exact extension match (e.g., '.pdf')
    if (normalizedType.startsWith('.')) {
      const fileExtension = `.${file.name.split('.').pop()?.toLowerCase()}`;
      return fileExtension === normalizedType;
    }

    const fileMediaType = file.type.toLowerCase();

    // Check Media (MIME) type match (e.g., 'application/pdf')
    if (normalizedType.includes('/')) {
      // Check general type match (e.g., 'image/*')
      if (normalizedType.includes('*')) {
        const baseType = normalizedType.split('/')[0];
        return fileMediaType.startsWith(`${baseType}/`);
      }

      return fileMediaType === normalizedType;
    }

    return false;
  });

/**
 * @param {File} file
 * @param {object} options
 * @param {string[]} [options.acceptedFileTypes] - Array of file types to accept
 * @param {number} [options.maxFileSizeMB] - Maximum file size in megabytes
 * @returns {{ isValid: boolean, messageDescriptor?: object, messageValues?: object }}
 */
export const validateFile = (file, { acceptedFileTypes, maxFileSizeMB }) => {
  if (!file) {
    return {
      isValid: false,
    };
  }

  if (acceptedFileTypes && acceptedFileTypes.length > 0) {
    const isValidFileType = validateFileType(acceptedFileTypes, file);
    if (!isValidFileType) {
      const acceptedTypesString = acceptedFileTypes.join(', ');
      return {
        isValid: false,
        messageDescriptor: messages.fileTypeNotSupported,
        messageValues: { acceptedTypes: acceptedTypesString },
      };
    }
  }

  if (maxFileSizeMB && file.size > maxFileSizeMB * 1024 * 1024) {
    return {
      isValid: false,
      messageDescriptor: messages.fileSizeExceedsLimit,
      messageValues: { maxSize: maxFileSizeMB },
    };
  }

  return { isValid: true };
};
